@if (Company && suppliedGridQueryData) {
  <div class="container-fluid d-flex flex-column h-100 g-0 p-0">
    <!-- VPDW-3111: The Add vendor / Invite vendor / Add vendor tutorial
         buttons that used to live here have moved to the parent
         <app-client-vendors> page header. The parent calls back into
         this component via @ViewChild. -->
    <div class="row row-padding flex-grow-1 g-0">
      <div class="col-12">
        <app-company-vendors-grid
          [gridName]="'MyVendorsGrid'"
          [suppliedQueryData]="suppliedGridQueryData"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          [Filters]="Filters"
          [FilterModel]="FilterModel"
          [(reloadGridData)]="refreshGrid"
          [suppressFieldDotNotation]="false"
          (dataGridQueryChanged)="dataGridQueryChanged.emit($event)"
          (rowClick)="action({ action: 'view', rowData: $event.data })"
          (actionEvent)="action($event)"
          (resetAllResultFilters)="onResetFilters($event)"
        ></app-company-vendors-grid>
      </div>
    </div>
  </div>
}
